import MonacoEditor, { monaco } from "react-monaco-editor";
import { useParams } from "react-router-dom";

import nightOwl from "monaco-themes/themes/Night Owl.json";
import { SERVER_WS_URL } from "../../config";

import useWebSocket, { ReadyState } from "react-use-websocket";
import { useEffect, useRef, useState } from "react";
import {
    ClientServerMessage,
    ClientServerMessageType,
} from "../../utils/structs";

export const Editor = () => {
    const { sessionId } = useParams();
    // const editorOptions = {};
    monaco.editor.defineTheme("night-owl", nightOwl as unknown as any);

    const [backendValue, setBackendValue] = useState("");
    const [fileName, setFileName] = useState("");
    const initalSet = useRef(false);
    const editor = useRef<null | monaco.editor.IStandaloneCodeEditor>();

    const socketURL = new URL(
        `/interface-connect-session/${sessionId}`,
        SERVER_WS_URL
    ).toString();

    const { sendMessage, lastMessage, readyState } = useWebSocket(socketURL);

    useEffect(() => {
        if (lastMessage !== null && lastMessage.data != null) {
            const messageData = JSON.parse(
                lastMessage.data
            ) as ClientServerMessage;
            if (messageData.MessageType !== ClientServerMessageType.ReadFile) {
                return;
            }
            const binary = Uint8Array.from(atob(messageData.FileContent), (c) =>
                c.charCodeAt(0)
            );
            const textData = new TextDecoder().decode(binary);
            // console.log(textData);
            setBackendValue(() => textData);
            setFileName(() => messageData.FileName);
            if (!initalSet.current) {
                initalSet.current = true;
                updateToBackendValue(textData, true, messageData.FileName);
            }
        }
    }, [lastMessage]);

    const updateToBackendValue = (
        override?: string,
        setModel?: boolean,
        overrideName?: string
    ) => {
        if (!editor.current) {
            return;
        }
        const cursorPosition = editor.current.getPosition();

        // work around for blinking, insert a space then delete it
        if (setModel) {
            const model = monaco.editor.createModel(
                override || backendValue,
                undefined,
                monaco.Uri.file(overrideName || fileName)
            );
            editor.current.setModel(model);
            editor.current.getModel()?.applyEdits([
                {
                    text: " ",
                    range: new monaco.Range(1, 1, 1, 1),
                },
            ]);
            editor.current.getModel()?.applyEdits([
                {
                    text: null,
                    range: new monaco.Range(1, 1, 1, 2),
                },
            ]);
        } else {
            editor.current.setValue(override || backendValue);
        }
        if (cursorPosition) editor.current.setPosition(cursorPosition);
    };

    const save = () => {
        if (!editor.current) return;
        if (readyState !== WebSocket.OPEN) return;

        const binary = new TextEncoder().encode(editor.current.getValue());

        const b64 = btoa(String.fromCharCode(...binary));

        const message: ClientServerMessage = {
            MessageType: ClientServerMessageType.WriteFile,
            FileContent: b64,
            // filename not needed because server already has it
            FileName: "",
        };

        sendMessage(JSON.stringify(message), false);
    };

    return (
        <div className="w-full h-full flex flex-col py-2 overflow-hidden bg-blue-950 text-gray-200">
            <div className="h-12 mx-12 flex flex-col justify-center">
                <div className="flex flex-row">
                    <p>
                        Now editing{" "}
                        <span className="ml-4">{fileName || "Loading"}</span>{" "}
                    </p>
                    <div className="flex-1 flex justify-end gap-3">
                        <button
                            className=" bg-green-800 hover:bg-green-900 text-white font-bold py-1 px-4 rounded -translate-y-1 btn btn-sm"
                            onClick={() => save()}
                        >
                            Save
                        </button>
                        <button
                            className="bg-blue-700 hover:bg-blue-800 text-white font-bold py-1 px-4 rounded -translate-y-1 btn btn-sm"
                            onClick={() => updateToBackendValue()}
                        >
                            Update To Backend Value
                        </button>
                    </div>
                </div>
            </div>
            <div
                className="flex-1 py-2"
                style={{ background: nightOwl.colors["editor.background"] }}
            >
                <MonacoEditor
                    width="100%"
                    height="100%"
                    theme="night-owl"
                    defaultValue="Loading"
                    editorDidMount={(e) => (editor.current = e)}
                    options={{
                        readOnly: !initalSet.current,
                        mouseWheelZoom: true,
                        fontSize: 14,
                    }}
                />
            </div>
            <div className="h-12 mx-12 flex flex-col justify-center">
                <h5 className="pt-2">Session: {sessionId}</h5>
            </div>
        </div>
    );
};
